import {
  Button,
  DynamicButton,
  StyledText,
} from "../../../../components/common";
import {
  BackIcon,
  CloseIcon,
  NoticeIcon,
  SuccessBoxIcon,
} from "../../../../components/svgs";
import { useTheme, useTrivia, useRatings } from "../../../../hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useState, useEffect } from "react";
import styled from "styled-components";




const feedbackMap = {
  gaming:[
    { name: "Questions are too difficult", isActive: false, id: 5 },
    { name: "Questions are not clear", isActive: false, id: 2 },
    {
      name: "Time to answer questions are too short",
      isActive: false,
      id: 4,
    },
    { name: "Boring rewards", isActive: false, id: 3 },
    { name: "Topics are boring", isActive: false, id: 6 },
    { name: "Other", isActive: false, id: 7 },
  ],
  offers:[
    { name: "Questions are too difficult", isActive: false, id: 5 },
    { name: "Questions are not clear", isActive: false, id: 2 },
    {
      name: "Time to answer questions are too short",
      isActive: false,
      id: 4,
    },
    { name: "Boring rewards", isActive: false, id: 3 },
    { name: "Topics are boring", isActive: false, id: 6 },
    { name: "Other", isActive: false, id: 7 },
  ],
  loyalty:[
    { name: "Questions are too difficult", isActive: false, id: 5 },
    { name: "Questions are not clear", isActive: false, id: 2 },
    {
      name: "Time to answer questions are too short",
      isActive: false,
      id: 4,
    },
    { name: "Boring rewards", isActive: false, id: 3 },
    { name: "Topics are boring", isActive: false, id: 6 },
    { name: "Other", isActive: false, id: 7 },
  ],
  events:[
    { name: "Questions are too difficult", isActive: false, id: 5 },
    { name: "Questions are not clear", isActive: false, id: 2 },
    {
      name: "Time to answer questions are too short",
      isActive: false,
      id: 4,
    },
    { name: "Boring rewards", isActive: false, id: 3 },
    { name: "Topics are boring", isActive: false, id: 6 },
    { name: "Other", isActive: false, id: 7 },
  ]
}


const EmojiButton = ({ emoji, text, onEmojiClick }) => {
  return (
    <EmojiContainer onClick={onEmojiClick}>
      <StyledText style={{ fontSize: 60, margin: -10 }}>{emoji}</StyledText>
      <StyledText style={{ fontFamily: "MTNRegular" }}>{text}</StyledText>
    </EmojiContainer>
  );
};

//FEEDBACK EMOJI VIEW
const FeedbackOptions = ({ onBackDropClick, onEmojiClick }) => {
  return (
    <FeedbackOptionsContainer>
      <StyledText style={{ fontSize: 16, textAlign: "center", width: "80%" }}>
        Give your feedback on
      </StyledText>
      <ReviewContainer>
        <EmojiButton
          emoji="😍"
          text="Satisfied"
          onEmojiClick={() => {
            onEmojiClick("satisfied");
          }}
        />
        <EmojiButton
          emoji="😐"
          text="Neutral"
          onEmojiClick={() => {
            onEmojiClick("neutral");
          }}
        />
        <EmojiButton
          emoji="😡"
          text="Unhappy"
          onEmojiClick={() => {
            onEmojiClick("unhappy");
          }}
        />
      </ReviewContainer>

      <StyledText onClick={onBackDropClick}>Not Now</StyledText>
    </FeedbackOptionsContainer>
  );
};
// NPS VIEW
const NpsRatingView = ({
  onSubmitted,
  background,
  updateRatingValues,
  disabled,
}) => {
  const [npsScore, setNpsScore] = useState([
    { score: "0", id: 0, isActive: false },
    { score: "1", id: 1, isActive: false },
    { score: "2", id: 2, isActive: false },
    { score: "3", id: 3, isActive: false },
    { score: "4", id: 4, isActive: false },
    { score: "5", id: 5, isActive: false },
    { score: "6", id: 6, isActive: false },
    { score: "7", id: 7, isActive: false },
    { score: "8", id: 8, isActive: false },
    { score: "9", id: 9, isActive: false },
    { score: "10", id: 10, isActive: false },
  ]);

  const changeNpsScore = (id) => {
    const update = npsScore.map((score) => {
      {
        if (id === score.id) {
          updateRatingValues("nps", score.score);
          return { ...score, isActive: true };
        } else {
          return { ...score, isActive: false };
        }
      }
    });
    setNpsScore(update);
  };

  return (
    <ModalContentContainer>
      <StyledText style={{ textAlign: "center", fontSize: 18 }}>
        How likely are you to recommend this to a friend?
      </StyledText>
      <StyledText
        style={{
          width: "90%",
          textAlign: "left",
          fontFamily: "MTNMediumItalic",
          color: "gray",
          marginBottom: -10,
        }}
      >
        Not at all likely
      </StyledText>

      <NPSFeedbackContainer>
        {npsScore.map((score) => (
          <button
            key={score.id}
            style={{
              border: `1px solid ${background}`,
              borderRadius: "50%",
              margin: 5,
              width: 40,
              height: 40,
              fontFamily: "MTNMedium, sans-serif",
              background: score.isActive ? background : "transparent",
              color: score.isActive ? "white" : background,
            }}
            onClick={() => changeNpsScore(score.id)}
          >
            {score.score}
          </button>
        ))}
      </NPSFeedbackContainer>
      <StyledText
        style={{
          width: "90%",
          textAlign: "right",
          fontFamily: "MTNMediumItalic",
          color: "gray",
          marginTop: -10,
        }}
      >
        Extremely likely
      </StyledText>

      <DynamicButton
        label={"Submit"}
        color={background}
        width={200}
        onClick={() => {
          //do something with the selected number
          onSubmitted();
        }}
        disabled={disabled}
      />
    </ModalContentContainer>
  );
};

//INPUT VIEW
const FeedbackInputModal = ({
  onBackDropClick,
  onSubmitted,
  background,
  updateRatingValues,
}) => {
  const [inputFeedback, setInputFeedback] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted Value:", inputFeedback);
    updateRatingValues("recommendations", inputFeedback);
    onSubmitted();
  };

  return (
    <ModalContentContainer>
      <StyledText>Any ideas on what we can do better?</StyledText>
      <FeedbackInputForm onSubmit={handleSubmit}>
        <input
          style={{ width: "100%", height: 70 }}
          placeholder="Tell us how we can improve"
          type="text"
          value={inputFeedback}
          onChange={(e) => setInputFeedback(e.target.value)}
        />

        <button
          style={{
            backgroundColor: background,
            borderRadius: 30,
            border: "none",
            width: "80%",
            height: 40,
            marginTop: 20,
            fontFamily: "MTNRegular",
            color: "white",
            fontSize: 14,
          }}
          type="submit"
        >
          Submit
        </button>
      </FeedbackInputForm>
    </ModalContentContainer>
  );
};

const TriviaRatingModal = ({
  onBackDropClick,
  onNotNowClick,
  featureTitle = "Trivia",
}) => {
  const { themeContext, theme } = useTheme();
  const { triviaRating, setTriviaRatingModal } = useTrivia();
  const {
    ratingValues,
    isSubmitting,
    submissionResponseData,
    submissionError,
    setSubmissionResponseData,
    submitRatings,
    updateRatingValues,
  } = useRatings();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let history = useHistory();

  //THANKS FOR FEEDBACK VIEW

  const ThanksForFeedbackModal = ({ onSubmitted }) => {
    return (
      <ModalContentContainer>
        <SuccessBoxIcon fill={background} />

        <StyledText>Thanks for your feedback</StyledText>

        <Button
          style={{ backgroundColor: background, width: "60%" }}
          onClick={onSubmitted}
        >
          <StyledText color="white">Ok</StyledText>
        </Button>
      </ModalContentContainer>
    );
  };

  //UNHAPPY OPTIONS VIEW
  const UnhappyOptionsModal = ({ onBackDropClick, onSubmitted, feedbackQuestions }) => {
    const [unhappyFeedback, setUnhappyFeedback] = useState(feedbackQuestions);

    const [feedback, setFeedback] = useState([]);

    const handleButtonClick = (id) => {
      const updatedFeedback = unhappyFeedback.map((item) =>
        item.id === id ? { ...item, isActive: !item.isActive } : item
      );
      setUnhappyFeedback(updatedFeedback);

      const selectedFeedback = updatedFeedback.filter((item) => item.isActive);
      setFeedback(selectedFeedback.map((item) => item.name));
    };

    return (
      <UnhappyContentContainer>
        <EmojiButton emoji="😡" text="Unhappy" />
        <div>
          <StyledText>What didn't you like?</StyledText>
          <StyledText style={{ fontFamily: "MTNRegular", fontSize: 10 }}>
            Select as many options that apply
          </StyledText>
        </div>

        <UnhappyFeedbackContainer>
          {unhappyFeedback.map(
            (tab) => (
              (
                <button
                  key={tab.id}
                  style={{
                    border: `1px solid ${background}`,
                    borderRadius: 30,
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    marginRight: 5,
                    marginTop: 10,
                    fontFamily: "MTNMedium, sans-serif",
                    background: tab.isActive ? background : "transparent",
                    color: tab.isActive ? "white" : background,
                    fontSize: 10,
                  }}
                  onClick={() => handleButtonClick(tab.id)}
                >
                  {tab.name}
                </button>
              )
            )
          )}
        </UnhappyFeedbackContainer>

        <DynamicButton
          label={"Submit"}
          color={background}
          width={200}
          onClick={() => {
            setInputView(true);
            setUnhappyView(false);
            updateRatingValues("unhappyFeedback", feedback);
          }}
          disabled={feedback.length === 0}
        />
      </UnhappyContentContainer>
    );
  };

  
  const [thanksView, setThanksView] = useState(false);
  const [inputView, setInputView] = useState(false);
  const [unhappyView, setUnhappyView] = useState(false);
  const [feedBackOpionsView, setFeedBackOpionsView] = useState(true);
  const [nspView, setNpsView] = useState(false);

  const [selectedEmoji, setSelectedEmoji] = useState("");

  return (
    <>
      <div>
        <div
          style={{
            position: "absolute",
            zIndex: 100,
            top: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.7)",
          }}
          onClick={onBackDropClick}
        ></div>
        <div
          style={{
            position: "absolute",
            zIndex: 100,
            width: "100%",
            bottom: 0,
          }}
        >
          <ContentContainer>
            <div
              style={{
                width: 50,
                height: 8,
                backgroundColor: "#cbcbcb",
                borderRadius: 10,
              }}
            />
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                marginTop: 5,
                marginBottom: 5,
              }}
            >
              <div onClick={onBackDropClick}>
                <BackIcon fill="transparent" />
              </div>
              <div onClick={onBackDropClick}>
                <CloseIcon fill="black" />
              </div>
            </div>
            {feedBackOpionsView && (
              <FeedbackOptions
                onEmojiClick={(value) => {
                  setSelectedEmoji(value);
                  updateRatingValues("rating", value);
                  setFeedBackOpionsView(false);
                  setNpsView(true);
                }}
              />
            )}
            {thanksView && (
              <ThanksForFeedbackModal
                onSubmitted={async () => {
                  await submitRatings();
                  onBackDropClick();
                }}
              />
            )}
            {inputView && (
              <FeedbackInputModal
                background={background}
                onSubmitted={() => {
                  setInputView(false);

                  if (selectedEmoji === "unsatisfied") {
                    setUnhappyView(true);
                  } else {
                    setThanksView(true);
                  }
                }}
                updateRatingValues={updateRatingValues}
              />
            )}
            {unhappyView && <UnhappyOptionsModal feedbackQuestions={feedbackMap.gaming}/>}
            {nspView && (
              <NpsRatingView
                background={background}
                onSubmitted={() => {
                  setNpsView(false);
                  if (selectedEmoji === "satisfied") {
                    setThanksView(true);
                  }
                  if (selectedEmoji === "neutral") {
                    setInputView(true);
                  }
                  if (selectedEmoji === "unhappy") {
                    setUnhappyView(true);
                  }
                }}
                updateRatingValues={updateRatingValues}
                disabled={!ratingValues.nps}
              />
            )}
          </ContentContainer>
        </div>
      </div>
    </>
  );
};

export default TriviaRatingModal;

const EmojiContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ReviewContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
`;

const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContentContainer = styled.div`
  box-sizing: border-box;
  padding: 20px;
  height: 60%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin-top: 70%;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
`;

const UnhappyFeedbackContainer = styled.div`
  flex-direction: row;
  overflow-x: auto;
  white-space: wrap;
  ms-overflow-style: none;
`;
const NPSFeedbackContainer = styled.div`
  flex-direction: row;
  padding: 20px;
  overflow-x: auto;
  white-space: wrap;
  ms-overflow-style: none;
`;
const UnhappyContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const FeedbackOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const FeedbackInputForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;
